const environmentBase = "https://dev-admin.tecnodim.tecfy.com.br";
const environmentLogin = "http://tecnodimweb.tecfy.com.br/login";
export default {
    apiUrl: environmentBase + '/api',
    externalLoginUlr: environmentBase,
    externalLoginUlrRedirect: environmentLogin,
}